import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { createAmountInputCodec } from './amount-input.js';
import { MoneyError } from './money.js';
/** Persist only canonical amounts; incomplete input remains local and never authorizes payment. */
export function useFundingAmountDraft(t0) {
  const $ = _c(44);
  const {
    method,
    currency,
    decimals,
    locale,
    amountUnits,
    persistence
  } = t0;
  let t1;
  if ($[0] !== currency || $[1] !== decimals || $[2] !== persistence) {
    t1 = persistence ? `morfi.funding.amount.v1:${JSON.stringify([persistence.scope, persistence.direction, currency, decimals])}` : null;
    $[0] = currency;
    $[1] = decimals;
    $[2] = persistence;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const key = t1;
  let t2;
  if ($[4] !== currency || $[5] !== decimals || $[6] !== key || $[7] !== locale || $[8] !== method) {
    t2 = JSON.stringify([method, currency, decimals, locale, key]);
    $[4] = currency;
    $[5] = decimals;
    $[6] = key;
    $[7] = locale;
    $[8] = method;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const identity = t2;
  let t3;
  if ($[10] !== decimals || $[11] !== locale) {
    t3 = createAmountInputCodec(locale, decimals);
    $[10] = decimals;
    $[11] = locale;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const codec = t3;
  let t4;
  if ($[13] !== amountUnits || $[14] !== codec || $[15] !== key || $[16] !== persistence) {
    t4 = function initialValue() {
      if (amountUnits !== null || !key || !persistence) {
        return null;
      }
      const saved = persistence.storage.get(key);
      return saved && /^\d{1,20}$/.test(saved) ? codec.format(BigInt(saved)) : null;
    };
    $[13] = amountUnits;
    $[14] = codec;
    $[15] = key;
    $[16] = persistence;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  const initialValue = t4;
  let t5;
  if ($[18] !== identity || $[19] !== initialValue) {
    t5 = () => ({
      identity,
      value: initialValue()
    });
    $[18] = identity;
    $[19] = initialValue;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  const [draft, setDraft] = useState(t5);
  if (draft.identity !== identity) {
    setDraft({
      identity,
      value: initialValue()
    });
  }
  let t6;
  if ($[21] !== draft.identity || $[22] !== draft.value || $[23] !== identity || $[24] !== initialValue) {
    t6 = draft.identity === identity ? draft.value : initialValue();
    $[21] = draft.identity;
    $[22] = draft.value;
    $[23] = identity;
    $[24] = initialValue;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  const current = t6;
  let t7;
  if ($[26] !== amountUnits || $[27] !== codec || $[28] !== current) {
    t7 = current ?? (amountUnits ? codec.format(BigInt(amountUnits)) : "");
    $[26] = amountUnits;
    $[27] = codec;
    $[28] = current;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  const value = t7;
  let t8;
  if ($[30] !== decimals || $[31] !== locale || $[32] !== value) {
    t8 = parseDraft(value, locale, decimals);
    $[30] = decimals;
    $[31] = locale;
    $[32] = value;
    $[33] = t8;
  } else {
    t8 = $[33];
  }
  const units = t8;
  let t9;
  if ($[34] !== decimals || $[35] !== identity || $[36] !== key || $[37] !== locale || $[38] !== persistence) {
    t9 = value_0 => {
      setDraft({
        identity,
        value: value_0
      });
      if (key && persistence) {
        persistence.storage.set(key, parseDraft(value_0, locale, decimals) ?? "");
      }
    };
    $[34] = decimals;
    $[35] = identity;
    $[36] = key;
    $[37] = locale;
    $[38] = persistence;
    $[39] = t9;
  } else {
    t9 = $[39];
  }
  let t10;
  if ($[40] !== t9 || $[41] !== units || $[42] !== value) {
    t10 = {
      value,
      units,
      setValue: t9
    };
    $[40] = t9;
    $[41] = units;
    $[42] = value;
    $[43] = t10;
  } else {
    t10 = $[43];
  }
  return t10;
}
function parseDraft(value, locale, decimals) {
  try {
    return createAmountInputCodec(locale, decimals).parse(value, 99999999999999999999n).toString();
  } catch (error) {
    if (error instanceof MoneyError) return null;
    throw error;
  }
}